"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommandLayoutsType = exports.MenuType = void 0;
require("@progress/kendo-ui");
const $ = require("jquery");
const Utilities_1 = require("../../javascript/Utilities");
const synerisMethods_1 = require("../Menu/synerisMethods");
const SelectionContext_1 = require("./SelectionContext");
const synerisMethodsCustomer = require("../Menu/synerisMethods_customer");
var MenuType;
(function (MenuType) {
    MenuType[MenuType["ToolBar"] = 1] = "ToolBar";
    MenuType[MenuType["ContextMenu"] = 2] = "ContextMenu";
})(MenuType = exports.MenuType || (exports.MenuType = {}));
class CommandLayoutsType {
    constructor(options) {
        const that = this;
        that.m_selectionContext = new SelectionContext_1.SelectionContextManager();
        that.m_options = $.extend({
            iconWsUrl: Utilities_1.synUtil.getWSUrl("Icon"),
            data: [],
            raiseBeforeExecuteMethod: false,
            viewId: 'default',
            renderMode: Utilities_1.synUtil.clientDeviceClass === "phone" ? "compact" : "full",
            orientation: Utilities_1.synUtil.clientDeviceClass === "phone" ? "vertical" : "horizontal",
            direction: Utilities_1.synUtil.clientDeviceClass === "phone" ? "bottom bottom bottom" : "default",
            iconSize: 32
        }, options);
        if (Utilities_1.synUtil.isHDScreen)
            that.m_options.iconSize = 64;
    }
    get SelectionContext() {
        return this.m_selectionContext;
    }
    static IsMethodAllowed(method, fullSelectionContext) {
        let bReturn = true;
        let nSelCount = fullSelectionContext.selectedIds ? fullSelectionContext.selectedIds.length : 0;
        let ids = fullSelectionContext.selectedIds;
        let parentId = fullSelectionContext.normalParentContext.parentId;
        let relId = fullSelectionContext.normalParentContext.parentRelId;
        let version = fullSelectionContext.version;
        if (fullSelectionContext.parentControl && (method.style & synerisMethods_1.methodStyles.UseSelectedObjectAsContextInTree)) {
            parentId = fullSelectionContext.parentControlParentContext.parentId;
            relId = fullSelectionContext.parentControlParentContext.parentRelId;
        }
        // Überprüfung der Einschränkungen bezügl. Selection-Count
        if (typeof method.selCount !== "undefined") {
            switch (method.selCount) {
                case -1:
                    break;
                case -2:
                    bReturn = nSelCount > 0;
                    break;
                case -3:
                    bReturn = nSelCount > -1 && nSelCount < 2;
                    break;
                default:
                    bReturn = nSelCount === method.selCount;
                    break;
            }
        }
        // Überprüfung ob es Einschränkungen auf Kategorien der gewählten Einträge gibt
        if (method.allowedCategories && ids) {
            let allowedCategories = method.allowedCategories;
            let oneId;
            let foundatpos;
            if ($.isArray(ids)) {
                for (let i = 0, max = ids.length; i < max; i++) {
                    oneId = ids[i].split("|")[2];
                    foundatpos = $.inArray(oneId, allowedCategories);
                    if (foundatpos < 0)
                        bReturn = false;
                }
            }
            else {
                oneId = ids;
                foundatpos = $.inArray(oneId[2], allowedCategories);
                if (foundatpos < 0)
                    bReturn = false;
            }
        }
        // Methodstyle Disabled
        if (method.style & synerisMethods_1.methodStyles.Disabled)
            bReturn = false;
        // Methodstyle NotReverseRel
        if (method.style & synerisMethods_1.methodStyles.NotReverseRel && relId < 0)
            bReturn = false;
        // Methodstyle NeedsParentContext
        if (method.style & synerisMethods_1.methodStyles.NeedsParentContext)
            if (!parentId && relId === SelectionContext_1.SpecialRelIds.Undefined)
                bReturn = false;
        // Methodstyles ForVersion & ForOldVersion
        if (version && bReturn) {
            if (!version.verCur) // Standardverhalten
                bReturn = false;
            // Methodstyle ForVersion
            if (method.style & synerisMethods_1.methodStyles.ForVersion) // Für alle Versionen aktiv setzen
                bReturn = true;
            // Methodstyle ForOldVersion
            if (method.style & synerisMethods_1.methodStyles.ForOldVersion) // Für alte Versionen aktiv setzen
                if (!version.verCur)
                    bReturn = true;
        }
        return bReturn;
    }
    prepareData(menuType, data, level, enableTooltip) {
        const that = this;
        let actLevel = level + 1;
        let overrideIcon = false;
        $.each(data, function (index, menuItem) {
            var _a;
            let menuCssClasses = [];
            if (menuItem.isSeparator) {
                menuCssClasses.push("separator");
                menuItem.text = '';
                menuItem.encoded = false;
                menuItem.enabled = false;
            }
            else {
                if (!menuItem.selCount)
                    menuItem.selCount = 1;
                if (menuItem.menuEntry) {
                    menuItem.method = menuItem.menuEntry;
                    // SelCount ggf. überschreiben
                    let methodArr = menuItem.method.split('.');
                    if (synerisMethods_1.synerisMethods.hasOwnProperty(methodArr[0]) && methodArr.length > 1)
                        if (synerisMethods_1.synerisMethods[methodArr[0]].hasOwnProperty(methodArr[1]))
                            if (synerisMethods_1.synerisMethods[methodArr[0]][methodArr[1]].hasOwnProperty('selCount'))
                                menuItem.selCount = synerisMethods_1.synerisMethods[methodArr[0]][methodArr[1]].selCount;
                    if (synerisMethodsCustomer.hasOwnProperty(methodArr[0]) && methodArr.length > 1)
                        if (synerisMethodsCustomer[methodArr[0]].hasOwnProperty(methodArr[1]))
                            if (synerisMethodsCustomer[methodArr[0]][methodArr[1]].hasOwnProperty('selCount'))
                                menuItem.selCount = synerisMethodsCustomer[methodArr[0]][methodArr[1]].selCount;
                }
                switch (menuType) {
                    case MenuType.ToolBar:
                        if (menuItem.icon)
                            if (actLevel === 1)
                                menuItem.imageUrl = that.m_options.iconWsUrl + "docid=" + menuItem.icon + '/' + that.m_options.iconSize;
                            else
                                menuItem.imageUrl = that.m_options.iconWsUrl + "docid=" + menuItem.icon + '/' + that.m_options.iconSize / 2; // Icons in SubMenu don'are smaller
                        else {
                            if (actLevel === 1)
                                menuItem.imageUrl = that.m_options.iconWsUrl + "name=" + "cgdvs.ico" + '/' + that.m_options.iconSize;
                            if ("compact" !== that.m_options.renderMode)
                                menuCssClasses.push("noIcon");
                        }
                        break;
                    case MenuType.ContextMenu:
                        if (menuItem.icon)
                            menuItem.imageUrl = that.m_options.iconWsUrl + "docid=" + menuItem.icon + '/' + that.m_options.iconSize;
                        else if ("compact" !== that.m_options.renderMode)
                            menuCssClasses.push("noIcon");
                        break;
                }
                if (!menuItem.style)
                    menuItem.style = synerisMethods_1.methodStyles.Default;
                if (menuType === MenuType.ToolBar) {
                    if (actLevel === 1) {
                        overrideIcon = false;
                        let curText = menuItem.text;
                        // Enable tooltips only for full render mode
                        if (enableTooltip && that.m_options.renderMode !== "compact" && menuItem.description) {
                            menuItem.text = String()
                                + '<span class="menutooltip" data-title="' + curText
                                + '" data-text="' + Utilities_1.synUtil.escapeHTMLAttribute(menuItem.description) + '">';
                            if (menuItem.icon) {
                                menuItem.text += '<img class="k-image" src="' + Utilities_1.synUtil.escapeHTMLAttribute(menuItem.imageUrl) + '"/>';
                                overrideIcon = true;
                            }
                            menuItem.text += curText + '</span>';
                            menuItem.encoded = false;
                        }
                        // Show text for all first layer entries for compact (i.e. phone) menu, since those are
                        // already nested inside a expand button.
                        let showText = menuItem.showText || that.m_options.renderMode === "compact" && actLevel === 1;
                        if ("compact" === that.m_options.renderMode) {
                            overrideIcon = true;
                            menuItem.text = "<span><i class='fa fa-bars' /></span>";
                            menuItem.encoded = false;
                        }
                        else if (menuItem.icon && !showText) {
                            overrideIcon = true;
                            menuItem.text = String()
                                + '<span class="menutooltip" data-title="' + Utilities_1.synUtil.escapeHTMLAttribute(curText)
                                + '" data-text="">'
                                + '<img class="k-image" src="' + Utilities_1.synUtil.escapeHTMLAttribute(menuItem.imageUrl) + '"/></span>';
                            menuItem.encoded = false;
                        }
                        if (((_a = menuItem.items) === null || _a === void 0 ? void 0 : _a.length) === 0)
                            menuCssClasses.push("hide");
                        if (overrideIcon)
                            menuItem.imageUrl = "";
                    }
                }
                else if (menuType === MenuType.ContextMenu) {
                    // Das wären die Tooltips für das ContextMenu zu implementieren. Sind aber derzeit nicht implementiert, da:
                    // 1. unüblich
                    // 2. verdeckt der Tooltip den darunter liegenden Menüpunkt
                }
            }
            let bIsSubMenuItem = (menuItem === null || menuItem === void 0 ? void 0 : menuItem.items);
            if (bIsSubMenuItem)
                menuCssClasses.push("synSubmenuItem");
            menuItem.cssClass = menuCssClasses.join(" ");
            menuItem.cssClassArray = menuCssClasses;
            if (bIsSubMenuItem)
                that.prepareData(menuType, menuItem.items, actLevel, enableTooltip);
        });
    }
    prepareAJAXData(menuType, ajaxData, kendoDataOptions) {
        const that = this;
        that.prepareData(menuType, ajaxData.items, 0, that.m_options.data.enableTooltip);
    }
    prepareForContextMenuInternal(items) {
        const that = this;
        let bAllInvisible = true;
        let bItemVisible = true;
        let bSeparatorAllowed = false;
        let lastVisibleSeparator;
        $.each(items, function (index, menuItem) {
            if (menuItem) {
                if (menuItem.items) {
                    // SubMenuItem
                    bItemVisible = that.prepareForContextMenuInternal(menuItem.items);
                    if (bItemVisible)
                        bSeparatorAllowed = true;
                }
                else if (menuItem.isSeparator) {
                    // Separator
                    if (bSeparatorAllowed) {
                        bItemVisible = bSeparatorAllowed;
                        bSeparatorAllowed = false;
                        lastVisibleSeparator = menuItem;
                    }
                    else
                        bItemVisible = false;
                }
                else {
                    // normaler Menüeintrag
                    bItemVisible = CommandLayoutsType.IsMethodAllowed(menuItem, that.m_selectionContext.FullSelectionContext);
                    if (bItemVisible)
                        bSeparatorAllowed = true;
                }
                if (bItemVisible)
                    bAllInvisible = false;
                else if (menuItem.cssClassArray.indexOf("hide") === -1) {
                    menuItem.cssClassArray.push("hide");
                    menuItem.cssClass = menuItem.cssClassArray.join(" ");
                }
            }
        });
        if ((lastVisibleSeparator) && (!bSeparatorAllowed))
            if (lastVisibleSeparator.cssClassArray.indexOf("hide") === -1) {
                lastVisibleSeparator.cssClassArray.push("hide");
                lastVisibleSeparator.cssClass = lastVisibleSeparator.cssClassArray.join(" ");
            }
        return (!bAllInvisible);
    }
    prepareForContextMenu(kendoDataOptions) {
        const that = this;
        let clonedItems = JSON.parse(JSON.stringify(that.m_ajaxDataContextMenu.items));
        that.prepareForContextMenuInternal(clonedItems);
        kendoDataOptions.success(clonedItems); // Hier wird das "Modell" des Menüs zurückgegeben
    }
    static AddTooltip($menuControl) {
        $menuControl.kendoTooltip({
            filter: "li.k-item:has(span.menutooltip)",
            content(e) {
                let target = e.target; // the element for which the tooltip is shown
                let tooltipelement = target.find("span.menutooltip");
                if (tooltipelement) {
                    let template = kendo.template('<div class="synTooltip"><div class="header">#=title#</div>#if(text){#<div class="text">#=text#</div>#}#</div>');
                    let data = {
                        title: tooltipelement.data("title"),
                        text: tooltipelement.data("text")
                    };
                    return template(data);
                }
                return undefined;
            },
            position: "bottom",
            autoHide: true,
            showAfter: 1000,
            show(e) {
                let elem = e.sender.popup.element;
                const that = this;
                // keep open
                that.target().add(elem).off("mouseenter").on("mouseenter", function () {
                    elem.attr("data-keepopen", "yes");
                });
                that.target().add(elem).off("mouseleave").on("mouseleave", function () {
                    elem.removeAttr("data-keepopen");
                    setTimeout(function () {
                        if (!elem.attr("data-keepopen")) {
                            elem.removeAttr("data-keepopen");
                            that.hide(elem);
                        }
                    }, 500);
                });
            }
        });
    }
    GetDataSource(menuType) {
        const that = this;
        let dataSource = new kendo.data.DataSource({
            transport: {
                read(kendoDataOptions) {
                    switch (menuType) {
                        case MenuType.ToolBar:
                            if (that.m_ajaxDataToolBar == undefined) {
                                Utilities_1.synUtil.getAJAXData({
                                    method: "POST",
                                    url: Utilities_1.synUtil.getWSUrl("ProfileMenuLayout") + '/' + that.m_options.viewId + (that.m_options.renderMode === "compact" ? "?mode=compact" : ""),
                                    done(data) {
                                        that.m_ajaxDataToolBar = data;
                                        that.prepareAJAXData(menuType, that.m_ajaxDataToolBar, kendoDataOptions);
                                        kendoDataOptions.success(that.m_ajaxDataToolBar.items); // Hier wird das "Modell" des Menüs zurückgegeben
                                    }
                                });
                            }
                            else
                                kendoDataOptions.success(that.m_ajaxDataToolBar.items); // Hier wird das "Modell" des Menüs zurückgegeben
                            break;
                        case MenuType.ContextMenu:
                            if (that.m_ajaxDataContextMenu == undefined) {
                                Utilities_1.synUtil.getAJAXData({
                                    method: "POST",
                                    url: Utilities_1.synUtil.getWSUrl("ProfileContextMenuLayout") + '/' + that.m_options.viewId + (that.m_options.renderMode === "compact" ? "?mode=compact" : ""),
                                    done(data) {
                                        that.m_ajaxDataContextMenu = data;
                                        that.prepareAJAXData(menuType, that.m_ajaxDataContextMenu, kendoDataOptions);
                                        that.prepareForContextMenu(kendoDataOptions);
                                    }
                                });
                            }
                            else
                                that.prepareForContextMenu(kendoDataOptions); // Hier wird das "Modell" des Menüs zurückgegeben
                            break;
                    }
                }
            }
        });
        return dataSource;
    }
    get RaiseBeforeExecuteMethod() {
        return this.m_options["raiseBeforeExecuteMethod"];
    }
}
exports.CommandLayoutsType = CommandLayoutsType;
